import { Component, OnInit } from "@angular/core";
import { LeadService } from "app/platform/lead/lead.service";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray,
} from "@angular/forms";
import { LoaderService } from "app/services/loader.service";
import { CategoryService } from "../category.service";
import { TouchSequence } from "selenium-webdriver";
import { THROW_IF_NOT_FOUND } from "@angular/core/src/di/injector";
declare var $: any;

@Component({
  selector: "app-category-hierachy",
  templateUrl: "./category-hierachy.component.html",
  styleUrls: ["./category-hierachy.component.css"],
  providers: [LeadService, CategoryService],
})
export class CategoryHierachyComponent implements OnInit {
  itemsShow: any;

  CreateLOBForm: FormGroup;
  CreateDepartmentForm: FormGroup;
  CreateSubDepartmentForm: FormGroup;
  CreateClass1Form: FormGroup;
  CreateBrandCodeForm:FormGroup;

  CreateSubClassForm: FormGroup;
  CreateMaterialCodeForm: FormGroup;
  EditLOBForm: FormGroup;
  EditDepartmentForm: FormGroup;
  EditSubDepartmentForm: FormGroup;
  EditClass1Form: FormGroup;

  EditSubClassForm: FormGroup;
  EditMaterialCodeForm: FormGroup;
  ProductTypeForm: FormGroup;
  ProductChildTypeForm: FormGroup;
  ProductVendorForm: FormGroup;
  AddSliForm: FormGroup;
  VendorProductEditForm: FormGroup;
  role:any;

  constructor(
    private formBuilder: FormBuilder,
    private LeadService: LeadService,
    private LoaderService: LoaderService,
    private CategoryService: CategoryService
  ) {}

  ngOnInit() {

    console.log(JSON.parse(localStorage.getItem('filtersValue')));
    this.Filter_data = JSON.parse(localStorage.getItem('filtersValue'))
    if(this.Filter_data){
    
     this.SearchString = this.Filter_data['search']?this.Filter_data['search']:'';
     this.selectType = this.Filter_data['type']?this.Filter_data['type']:'';

    }
    this.creatingFOrms();
    this.getlistItems();
    this.getUOMList();
    this.GetProductList("");
    this.getVendorList();
    this.setSelectBoxvalues();
    this.getBrandsList();
    this.listOfslicats();
    this.getCategorysForWarhouse()
    this.itemsShow = "MaterialCode";
    console.log (this.SearchString)
   
  }
  Filter_data
  creatingFOrms() {
    this.CreateLOBForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      lob_code: new FormControl("", [Validators.required,Validators.minLength(2),Validators.maxLength(2)]),
      sli_category: new FormControl("", Validators.required),
    });
    this.CreateBrandCodeForm= this.formBuilder.group({
      name: new FormControl("", [Validators.required]),
      code: new FormControl("", [Validators.required,Validators.minLength(3),Validators.maxLength(3)]),
    });
    this.CreateDepartmentForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      depart_code: new FormControl("", [Validators.required,Validators.minLength(2),Validators.maxLength(2)]),
    });
    this.CreateSubDepartmentForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      sub_depart_code: new FormControl("", [Validators.required,Validators.minLength(2),Validators.maxLength(2)]),
    });
    this.CreateClass1Form = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      class_code: new FormControl("", [Validators.required,Validators.minLength(2),Validators.maxLength(2)]),
    });
    this.CreateSubClassForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      category_class_id: new FormControl("", Validators.required),
      sub_class_code: new FormControl("", [Validators.required,Validators.minLength(2),Validators.maxLength(2)]),
    });
    this.CreateMaterialCodeForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("",Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      category_class_id: new FormControl("", Validators.required),
      category_subclass_id: new FormControl("", Validators.required),
      mc_code: new FormControl("", [Validators.required,Validators.minLength(3),Validators.maxLength(3)]),
    });
    this.EditLOBForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      lob_code: new FormControl("", Validators.required),
    });
    this.EditDepartmentForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      depart_code: new FormControl("", Validators.required),
    });
    this.EditSubDepartmentForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      sub_depart_code: new FormControl("", Validators.required),
    });
    this.EditClass1Form = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      class_code: new FormControl("", Validators.required),
    });
    this.EditSubClassForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      category_class_id: new FormControl("", Validators.required),
      sub_class_code: new FormControl("", Validators.required),
    });
    this.EditMaterialCodeForm = this.formBuilder.group({
      name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      category_class_id: new FormControl("", Validators.required),
      category_subclass_id: new FormControl("", Validators.required),
      mc_code: new FormControl("", Validators.required),
    });
    this.ProductChildTypeForm = this.formBuilder.group({
      item_name: new FormControl("", Validators.required),
      master_line_item_id: new FormControl(""),
      brand_code: new FormControl(""),
      // sku: new FormControl("", Validators.required),
      brand_id: new FormControl("", Validators.required),
      tax: new FormControl(""),
      sli_dynamic_attributes_attributes: this.formBuilder.array([
        this.buildItem2(),
      ]),
    });
    this.ProductVendorForm = this.formBuilder.group({
      childsku: new FormControl(""),
      vendorName: new FormControl("", Validators.required),
      vendorCode: new FormControl("", Validators.required),
      ItemCost: new FormControl("", Validators.required),
      priority: new FormControl(false, Validators.required),
      child_line_item_id: new FormControl("", Validators.required),
    });
    this.ProductTypeForm = this.formBuilder.group({
      mli_name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      category_class_id: new FormControl("", Validators.required),
      category_subclass_id: new FormControl("", Validators.required),
      category_material_code_id: new FormControl("", Validators.required),
      zoho_category_id:new FormControl("", Validators.required),
      unit: new FormControl("", Validators.required),
      tax_percent: new FormControl("", Validators.required),
      mli_type: new FormControl("2021"),

      sku_code: new FormControl(""),
      mli_attributes_attributes: this.formBuilder.array([]),
    });
    this.AddSliForm = this.formBuilder.group({
      quantity: new FormControl("", Validators.required),
      rate: new FormControl("", Validators.required),
      specs: new FormControl("", Validators.required),
      tax_type: new FormControl("", Validators.required),
      cli_id: new FormControl(""),
    });
    this.VendorProductEditForm = this.formBuilder.group({
      ItemCost: new FormControl("", Validators.required),
      priority: new FormControl("", Validators.required),
      child_line_item_id: new FormControl("", Validators.required),
      VendorId: new FormControl("", Validators.required),
      VendorCode: new FormControl("", Validators.required),
    });

    this.createProForm();
    this.role = localStorage.getItem('user')

  }
  resetForms() {
    this.CreateLOBForm.reset();
    this.CreateDepartmentForm.reset();
    this.CreateSubDepartmentForm.reset();
  }
  createProForm() {
    this.ProductTypeForm = this.formBuilder.group({
      mli_name: new FormControl("", Validators.required),
      category_lob_id: new FormControl("", Validators.required),
      category_department_id: new FormControl("", Validators.required),
      category_sub_department_id: new FormControl("", Validators.required),
      category_class_id: new FormControl("", Validators.required),
      category_subclass_id: new FormControl("", Validators.required),
      category_material_code_id: new FormControl("", Validators.required),
      unit: new FormControl("", Validators.required),
      tax_percent: new FormControl("", Validators.required),
      mli_type: new FormControl("2021"),
      zoho_category_id:new FormControl("", Validators.required),
      sku_code: new FormControl(""),
      mli_attributes_attributes: this.formBuilder.array([]),
    });
  }

  buildItem() {
    return new FormGroup({
      attr_name: new FormControl("", Validators.required),
      required: new FormControl(false, Validators.required),
      attr_type: new FormControl("", Validators.required),
      attr_data_type: new FormControl("string"),
      id: new FormControl(""),
      dropdown_options: new FormControl([]),
    });
  }

  buildItem2() {
    return new FormGroup({
      attr_value: new FormControl("", Validators.required),
      id: new FormControl(""),
      mli_attribute_name: new FormControl(""),
      mli_attribute_id: new FormControl(""),
      mli_attribute_type: new FormControl(""),
      mli_attribute_value: new FormControl(""),
      mli_attribute_required: new FormControl(""),
    });
  }

  pushAttributes(product) {
    return product.get("mli_attributes_attributes").push(this.buildItem());
  }
  pushAttributeschild(product) {
    return product
      .get("sli_dynamic_attributes_attributes")
      .push(this.buildItem2());
  }
  getAttributes(product) {
    return product.get("mli_attributes_attributes").controls;
  }
  getAttributeschild(product) {
    return product.get("sli_dynamic_attributes_attributes").controls;
  }

  erroralert: any;
  errorMessage: any;
  successalert;
  successMessage;
  SearchString: any = "";
  errorMessageShow(msg) {
    this.erroralert = true;
    this.errorMessage = msg;
    setTimeout(
      function () {
        this.erroralert = false;
      }.bind(this),
      2000
    );
  }
  successMessageShow(msg) {
    this.successalert = true;
    this.successMessage = msg;
    setTimeout(
      function () {
        this.successalert = false;
      }.bind(this),
      2000
    );
  }
  getlistItems() {
    this.getClassList();
    this.getLOBSList();
    this.getDepartmentList();
    this.getMaterialList();
    this.getSubClassList();
    this.getSubDepartmentsList();
    this.getBrandsList();
  }

  LOBlist: any;
  DepartmentList: any;
  SubDepartmentList: any;
  classList: any;
  SubClassList: any;
  MaterialList: any;
  LOBDefault: any;
  departDefault: any;
  subdepartDefault;
  classDefault;
  subclassDefault;
  matcodeDefault;
  cardHeight:any= '700px';
  btn1Color:any=''
  btn2Color:any=''
  btn3Color:any=''
  btn4Color:any=''
  btn5Color:any=''
  btn6Color:any='#8f1e21'
  lineHeight:any='650px'
  showitems(e) {
    if(e=='LOB'){
      this.lineHeight='405px'
      this.cardHeight='455px';
      this.btn1Color='#8f1e21'
      this.btn2Color=''
      this.btn3Color=''
      this.btn4Color=''
      this.btn5Color=''
      this.btn6Color=''
      this.btn7Color=''
    }else if(e=='Department'){
      this.lineHeight='405px'
      this.btn1Color=''
      this.btn2Color='#8f1e21'
      this.btn3Color=''
      this.btn4Color=''
      this.btn5Color=''
      this.btn6Color=''
      this.btn7Color=''
      this.cardHeight='455px';
    }else if(e=='SubDepartment'){
      this.lineHeight='430px'
      this.cardHeight='480px'
      this.btn1Color=''
      this.btn2Color=''
      this.btn3Color='#8f1e21'
      this.btn4Color=''
      this.btn5Color=''
      this.btn6Color=''
      this.btn7Color=''
    }else if(e=='Class1'){
      this.lineHeight='500px'
      this.cardHeight='550px'
      this.btn1Color=''
      this.btn2Color=''
      this.btn3Color=''
      this.btn4Color='#8f1e21'
      this.btn5Color=''
      this.btn6Color=''
      this.btn7Color=''
    }else if(e=='SubClass'){
      this.lineHeight='600px'
      this.cardHeight='650px'
      this.btn1Color=''
      this.btn2Color=''
      this.btn3Color=''
      this.btn4Color=''
      this.btn5Color='#8f1e21'
      this.btn6Color=''
      this.btn7Color=''
    }else if(e=='MaterialCode'){
      this.lineHeight='650px'
      this.cardHeight='700px'
      this.btn1Color=''
      this.btn2Color=''
      this.btn3Color=''
      this.btn4Color=''
      this.btn5Color=''
      this.btn7Color=''
      this.btn6Color='#8f1e21'
    } else if(e == 'BrandCode'){
      this.lineHeight='405px'
      this.cardHeight='455px';
      this.btn1Color=''
      this.btn2Color=''
      this.btn3Color=''
      this.btn4Color=''
      this.btn5Color=''
      this.btn6Color=''
      this.btn7Color = '#8f1e21'
    }
  
  
    this.itemsShow = e;
    this.resetForms();
    this.creatingFOrms();
    this.DepartmentListFilter = [];
    this.SubDepartmentFilter = [];
    this.ClassesFilter = [];
    this.SubClassesFilter = [];
  }
  btn7Color:any;

  setSelectBoxvalues() {
    this.LOBDefault = "";
    this.departDefault = "";
    this.subdepartDefault = "";
    this.classDefault = "";
    this.subclassDefault = "";
    this.matcodeDefault = "";
  }
  DepartmentListFilter;
  SubDepartmentFilter;
  ClassesFilter: any;
  SubClassesFilter: any;
  getLOBSList() {
    this.LeadService.getAllLOBS().subscribe((res) => {
      this.LOBlist = res.category_lobs;
    });
  }
  dep_id;
  Sub_dep_id: any;
  getDepartmentListFilter(e) {
    this.LoaderService.display(true);
    this.dep_id = e;
    this.CreateSubDepartmentForm.controls["category_department_id"].setValue(
      ""
    );

    this.CreateClass1Form.controls["category_department_id"].setValue("");
    this.CreateSubClassForm.controls["category_department_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_department_id"].setValue("");

    this.CreateClass1Form.controls["category_sub_department_id"].setValue("");
    this.CreateSubClassForm.controls["category_sub_department_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_sub_department_id"].setValue(
      ""
    );

    this.CreateSubClassForm.controls["category_class_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_class_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_subclass_id"].setValue("");

    this.ProductTypeForm.controls["category_department_id"].setValue("");
    this.ProductTypeForm.controls["category_sub_department_id"].setValue("");
    this.ProductTypeForm.controls["category_class_id"].setValue("");
    this.ProductTypeForm.controls["category_subclass_id"].setValue("");
    this.ProductTypeForm.controls["category_material_code_id"].setValue("");

    this.EditSubDepartmentForm.controls["category_department_id"].setValue("");
    this.EditSubDepartmentForm.controls["category_department_id"].setValue("");
    this.EditClass1Form.controls["category_department_id"].setValue("");
    this.EditSubClassForm.controls["category_department_id"].setValue("");
    this.EditMaterialCodeForm.controls["category_department_id"].setValue("");

    this.LeadService.getAllDeapartmentsfilter(e).subscribe((res) => {
      this.LoaderService.display(false);
      this.DepartmentListFilter = res.category_departments;
      this.SubDepartmentFilter = [];
      this.ClassesFilter = [];
      this.SubClassesFilter = [];
      this.MaterialCodeFilter = [];
    });
  }
  getSubDepartmentsListFilter(e) {
    this.LoaderService.display(true);
    this.Sub_dep_id = e;

    this.CreateClass1Form.controls["category_sub_department_id"].setValue("");
    this.CreateSubClassForm.controls["category_sub_department_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_sub_department_id"].setValue(
      ""
    );
    this.CreateSubClassForm.controls["category_sub_department_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_class_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_subclass_id"].setValue("");
    this.CreateClass1Form.controls["category_sub_department_id"].setValue("");
    this.EditClass1Form.controls["category_sub_department_id"].setValue("");
    this.EditSubClassForm.controls["category_sub_department_id"].setValue("");
    this.EditMaterialCodeForm.controls["category_sub_department_id"].setValue(
      ""
    );
    this.CreateSubClassForm.controls["category_class_id"].setValue("");
    this.ProductTypeForm.controls["category_sub_department_id"].setValue("");
    this.ProductTypeForm.controls["category_class_id"].setValue("");
    this.ProductTypeForm.controls["category_subclass_id"].setValue("");
    this.ProductTypeForm.controls["category_material_code_id"].setValue("");

    this.LeadService.getAllSubDeapartmentsFilter(this.dep_id, e).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.SubDepartmentFilter = res.category_sub_departments;
        this.ClassesFilter = [];
        this.SubClassesFilter = [];
        this.MaterialCodeFilter = [];
      }
    );
  }
  MaterialCodeFilter;
  getMaterialCodeFilter(e) {
    this.LoaderService.display(true);
    this.ProductTypeForm.controls["category_material_code_id"].setValue("");
    this.LeadService.getAllMaterialFilter(
      this.dep_id,
      this.Sub_dep_id,
      this.class_id,
      this.SubClass_Id,
      e
    ).subscribe((res) => {
      this.LoaderService.display(false);
      this.MaterialCodeFilter = res.category_material_codes;
    });
  }
  class_id: any;
  getClassListFilter(e) {
    this.LoaderService.display(true);
    this.class_id = e;
    console.log(this.class_id);
    this.CreateSubClassForm.controls["category_class_id"].setValue("");
    this.CreateMaterialCodeForm.controls["category_class_id"].setValue("");
    this.EditSubClassForm.controls["category_class_id"].setValue("");
    this.EditMaterialCodeForm.controls["category_class_id"].setValue("");
    this.ProductTypeForm.controls["category_class_id"].setValue("");
    this.ProductTypeForm.controls["category_subclass_id"].setValue("");
    this.ProductTypeForm.controls["category_material_code_id"].setValue("");

    this.LeadService.getAllClassFilters(
      this.dep_id,
      this.Sub_dep_id,
      e
    ).subscribe((res) => {
      this.ClassesFilter = res.category_classes;
      this.SubClassesFilter = [];
      this.MaterialCodeFilter = [];
      this.LoaderService.display(false);
    });
  }
  SubClass_Id;
  getSubClassListFilter(e) {
    this.LoaderService.display(true);
    this.SubClass_Id = e;
    this.CreateMaterialCodeForm.controls["category_subclass_id"].setValue("");
    this.EditMaterialCodeForm.controls["category_subclass_id"].setValue("");
    this.ProductTypeForm.controls["category_subclass_id"].setValue("");
    this.ProductTypeForm.controls["category_material_code_id"].setValue("");
    this.LeadService.getAllSubClassFilters(
      this.dep_id,
      this.Sub_dep_id,
      this.class_id,
      e
    ).subscribe((res) => {
      this.LoaderService.display(false);
      this.SubClassesFilter = res.category_subclasses;
      this.MaterialCodeFilter = [];
    });
  }
  getDepartmentList() {
    this.LeadService.getAllDeapartments().subscribe((res) => {
      this.DepartmentList = res.category_departments;
    });
  }
  getSubDepartmentsList() {
    this.LeadService.getAllSubDeapartments().subscribe((res) => {
      this.SubDepartmentList = res.category_sub_departments;
    });
  }
  getClassList() {
    this.LeadService.getAllClass().subscribe((res) => {
      this.classList = res.category_classes;
      console.log(this.classList);
    });
  }
  getSubClassList() {
    this.LeadService.getAllSubClass().subscribe((res) => {
      this.SubClassList = res.category_subclasses;
    });
  }
  getMaterialList() {
    this.LeadService.getAllmaterail().subscribe((res) => {
      this.MaterialList = res.category_material_codes;
    });
  }
  createLOB() {
    this.LoaderService.display(true);
    this.LeadService.createLOB(this.CreateLOBForm.value).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Created Successfully");
        this.getlistItems();
        this.CreateLOBForm.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  createDepartment() {
    this.LoaderService.display(true);
    this.LeadService.createDepartment(
      this.CreateDepartmentForm.value
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("Department Created Successfully");
        this.getlistItems();
        this.CreateDepartmentForm.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  createSubDepartment() {
    this.LoaderService.display(true);
    this.LeadService.createSubDepartment(
      this.CreateSubDepartmentForm.value
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow(" SUB Department Created Successfully");
        this.getlistItems();
        this.CreateSubDepartmentForm.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  createClass() {
    this.LoaderService.display(true);
    this.LeadService.createClass(this.CreateClass1Form.value).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow(" Class Created Successfully");
        this.getlistItems();
        this.CreateClass1Form.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  createSubClass() {
    this.LoaderService.display(true);
    this.LeadService.createSubClass(this.CreateSubClassForm.value).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow(" Sub Class Created Successfully");
        this.getlistItems();
        this.CreateSubClassForm.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  creatematcode() {
    this.LoaderService.display(true);
    this.LeadService.createMaterial(
      this.CreateMaterialCodeForm.value
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow(" Material Code Created Successfully");
        this.getlistItems();
        this.CreateMaterialCodeForm.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  getQuoteModalHideBs() {
    $("#getQuoteModalHeader").on("hide.bs.modal", function () {
      if (
        $("#get-quote-container-header").hasClass(
          "get-quote-container-header-show"
        )
      ) {
        $("#get-quote-container-header").removeClass(
          "get-quote-container-header-show"
        );
        $("#get-quote-container-header").modal("hide");
      } else {
        $("#get-quote-container-header").addClass(
          "get-quote-container-header-show"
        );
      }
    });
  }
  expansion: any = "hir";
  getQuoteContainer() {
    console.log("hi");
    $("#getQuoteModalHeader").modal("show");
    $("#get-quote-container-header").addClass(
      "get-quote-container-header-show"
    );
    $(".get-quote-wrapper").hide();

    $(".get-quote-wrapper").animate({
      width: "toggle",
    });
    this.creatingFOrms();
    this.productTypesel = "numberone";
    this.editOrCreateValidator = "";
  }
  getQuoteContainerquit() {
    $("#getQuoteModalHeader").modal("hide");
    $("#get-quote-container-header").removeClass(
      "get-quote-container-header-show"
    );
    $(".get-quote-wrapper").hide();
    this.DepartmentListFilter = [];
    this.SubDepartmentFilter = [];
    this.ClassesFilter = [];
    this.SubClassesFilter = [];
  }
  skuProduct: any;
  openVendorPanel() {
    $("#getQuoteModalHeader2").modal("show");
    $("#get-quote-container-header2").addClass(
      "get-quote-container-header-show"
    );
    $(".get-quote-wrapper").hide();

    $(".get-quote-wrapper").animate({
      width: "toggle",
    });
  }
  getQuoteContainer2(e, e2) {
    console.log(e, e2);
    this.openVendorPanel();
    this.creatingFOrms();
    this.productTypeselchild = "numberonechild";
    this.skuProduct = e;
    this.ProductChildTypeForm.controls["master_line_item_id"].setValue(e2);
    this.EditOrCreateForChild = "";
  }
  getQuoteContainerquit2() {
    $("#getQuoteModalHeader2").modal("hide");
    $("#get-quote-container-header2").removeClass(
      "get-quote-container-header-show"
    );
    $(".get-quote-wrapper").hide();
  }
  productTypesel: any = "numberone";
  productSet(e) {
    this.productTypesel = e;
  }
  uom_list = [];

  getUOMList() {
    this.uom_list = [];
    this.CategoryService.getUOMList().subscribe(
      (res) => {
        this.uom_list = res;
      },
      (error) => {}
    );
  }
  productSetchild(e) {
    this.productTypeselchild = e;
  }
  ChildEditorCreate: any = "";
  SubmitPROcode(data2) {
    console.log(data2);
    if (data2.mli_attributes_attributes.length > 0) {
      for (var i = 0; i < data2.mli_attributes_attributes.length; i++) {
        console.log(data2.mli_attributes_attributes[i].dropdown_options);
        if (
          Array.isArray(data2.mli_attributes_attributes[i].dropdown_options) ==
          false
        ) {
          data2.mli_attributes_attributes[i].dropdown_options =
            data2.mli_attributes_attributes[i].dropdown_options.split(",");
          if (data2.mli_attributes_attributes[i].dropdown_options.length == 0) {
            this.errorMessageShow(
              "Please give dropdown options properly with comma seperated"
            );
          }
        }
      }
    }

    let data = {
      master_line_item: data2,
    };

    this.LoaderService.display(true);
    this.LeadService.createProduct(data).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("Product Created Successfully");
        this.ProductTypeForm.reset();
        this.createProForm();
        this.productTypesel = "numberone";
        this.GetProductList(this.current_page);
        this.getQuoteContainerquit();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }

  validatorofForm() {
    if (
      this.ProductTypeForm.controls["mli_name"].valid &&
      this.ProductTypeForm.controls["category_lob_id"].valid &&
      this.ProductTypeForm.controls["category_department_id"].valid &&
      this.ProductTypeForm.controls["category_sub_department_id"].valid &&
      this.ProductTypeForm.controls["category_class_id"].valid &&
      this.ProductTypeForm.controls["category_subclass_id"].valid &&
      this.ProductTypeForm.controls["category_material_code_id"].valid &&
      this.ProductTypeForm.controls["unit"].valid &&
      this.ProductTypeForm.controls["tax_percent"].valid && 
      this.ProductTypeForm.controls["zoho_category_id"].valid
    ) {
      return false;
    } else {
      return true;
    }
  }
  headers_res;
  per_page = 10;
  total_page;
  current_page;
  ListOfProduct: any = [];
  GetProductList(e) {
    e = e ? e : "";
    let string = this.SearchString;
    this.SetLocalStorate('search',string)

    this.LoaderService.display(true);
    this.LeadService.ListOfPRoduct(e, string,this.selectType ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.headers_res = res.headers._headers;
        this.per_page = this.headers_res.get("x-per-page");
        this.total_page = this.headers_res.get("x-total");
        this.current_page = this.headers_res.get("x-page");
        res = res.json();
        this.ListOfProduct = res.master_line_items;
        this.getChilditemListWithoutError(this.masterLineItemId,"")
      },
      (err) => {
        this.LoaderService.display(false);
        this.ListOfProduct = [];
      }
    );
  }
  headers_res2;
  per_page2 = 10;
  total_page2;
  current_page2;
  ListOfProduct2: any = [];
  GetProductList2(e) {
    e = e ? e : "";
  }
  productTypeselchild: any = "numberonechild";
  row: any = [""];
  masterSKU;
  masterLineItemId;
  masterLinteItem: any;
  toggleRow(pro, i) {
    console.log("hi");
    console.log(this.row[0], pro.id);
    if (this.row[0] !== pro.id) {
      this.expansion = pro.id;
      this.row[0] = pro.id;
      this.getChilditemList(pro.id, "");
      this.masterSKU = pro.sku_code;
      this.masterLineItemId = pro.id;
      this.masterLinteItem = pro;
    } else {
      this.row[0] = "";
      this.expansion = "";
    }
  }
  VendorList: any;
  ChildListPRo: any = [];
  getChilditemList(id, e) {
    e = e ? e : "";
    let string = this.search_type == 'parent'?"":this.SearchString;
    console.log(string,this.search_type);
    this.LoaderService.display(true);
    this.LeadService.ListOfChilds(id, e,string,this.selectType).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.headers_res2 = res.headers._headers;
        this.per_page2 = this.headers_res2.get("x-per-page");
        this.total_page2 = this.headers_res2.get("x-total");
        this.current_page2 = this.headers_res2.get("x-page");
        res = res.json();

        this.ChildListPRo = res.child_line_items;
        if (this.ChildListPRo.length == 0) {
          this.errorMessageShow("No child item present for this Master Item");
          this.expansion = "";
          this.row[0] = "";
        }
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  getChilditemListWithoutError(id, e) {

    e = e ? e : "";
    id = id?id:"";
    let string = this.search_type == 'parent'?"":this.SearchString;
    console.log(string,this.search_type);
    this.LoaderService.display(true);
    this.LeadService.ListOfChilds(id, e,string,this.selectType).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.headers_res2 = res.headers._headers;
        this.per_page2 = this.headers_res2.get("x-per-page");
        this.total_page2 = this.headers_res2.get("x-total");
        this.current_page2 = this.headers_res2.get("x-page");
        res = res.json();

        this.ChildListPRo = res.child_line_items;
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }

  getVendorList() {
    this.LeadService.ListOfVendors().subscribe((res) => {
      console.log(res);
      this.VendorList = res.vendors;
      console.log(this.VendorList);
    });
  }
  childItemId;
  ChildSku;
  submitchildpro() {
    this.LoaderService.display(true);
    this.LeadService.createProductchild(
      this.ProductChildTypeForm.value
    ).subscribe(
      (res) => {
        console.log(res);
        this.LoaderService.display(false);
        this.ProductChildTypeForm.reset();
        this.creatingFOrms();
        this.successMessageShow("Child Item Created Successfully");
        this.ProductVendorForm.controls["childsku"].setValue(
          res.child_line_item.item_name
        );
        this.ProductVendorForm.controls["child_line_item_id"].setValue(
          res.child_line_item.id
        );
        this.childItemId = res.child_line_item.id;
        this.ChildSku = res.child_line_item.item_name;
        this.GetProductList(this.current_page);
        this.getChilditemListWithoutError(
          this.masterLineItemId,
          this.current_page2
        );
        this.productTypeselchild = "numbertwochild";
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  SubmitPROcodevendor() {
    console.log(this.childOfmas);
    if (this.ProductVendorForm.controls["priority"].value == true) {
      this.CheckingPriorityEndpoint(this.childItemId);
    } else {
      this.LoaderService.display(true);
      this.LeadService.CreateVendorType(this.ProductVendorForm.value).subscribe(
        (res) => {
          console.log(res);
          this.LoaderService.display(false);
          if (res.message) {
            this.successMessageShow(res.message);
          } else {
            this.successMessageShow("Vendor product Created successfully");
          }

          this.ProductVendorForm.reset();
          this.creatingFOrms();

          this.GetProductList(this.current_page);
          this.getQuoteContainerquit2();

          this.getChilditemListWithoutError(
            this.masterLineItemId,
            this.current_page2
          );

          this.ViewVendor2(this.childOfmas);

          this.ProductVendorForm.controls["child_line_item_id"].setValue(
            this.childItemId
          );
          this.ProductVendorForm.controls["childsku"].setValue(this.ChildSku);
        },
        (err) => {
          this.LoaderService.display(false);
          this.errorMessageShow(JSON.parse(err["_body"]).message);
        }
      );
    }
  }
  vendorViewListforRevise = [];

  addVendorToChild(id, sku) {
    this.ProductVendorForm.controls["child_line_item_id"].setValue(id);
    this.ProductVendorForm.controls["childsku"].setValue(sku);
    this.openVendorPanel();
    this.productTypeselchild = "numbertwochild";
    this.childItemId = id;
    this.ChildSku = sku;
  }
  vendorViewList: any = [];
  childofCat: any;
  childOfmas;
  ViewVendor(child) {
    this.childOfmas = child;
    if (child.id) {
      this.LoaderService.display(true);
      this.LeadService.getVendorsForchild(child.id).subscribe(
        (res) => {
          console.log(res);
          this.vendorViewList = res.vendor_products;
          this.childofCat = child;
          this.LoaderService.display(false);
          $("#glassAnimals").modal("show");
        },
        (err) => {
          this.LoaderService.display(false);
          this.errorMessageShow(JSON.parse(err["_body"]).message);
        }
      );
    }
  }
  ViewVendor2(child) {
    this.childOfmas = child;
    if (child.id) {
      this.LoaderService.display(true);
      this.LeadService.getVendorsForchild(child.id).subscribe(
        (res) => {
          console.log(res);
          this.vendorViewList = res.vendor_products;
          this.childofCat = child;
          this.LoaderService.display(false);
        },
        (err) => {
          this.LoaderService.display(false);
          this.errorMessageShow(JSON.parse(err["_body"]).message);
        }
      );
    }
  }
  modalclose() {
    this.getQuoteContainerquit2();
  }
  deleteItem(id) {
    if (confirm("Are you sure to delete Child Item") == true) {
      this.LoaderService.display(true);
      this.LeadService.DeleteChilds(id).subscribe(
        (res) => {
          this.GetProductList(this.current_page);
          this.LoaderService.display(false);
          this.successMessageShow("Child item Deleted Successfully");
          this.getChilditemList(this.masterLineItemId, this.current_page2);
        },
        (err) => {
          this.LoaderService.display(false);
          this.errorMessageShow(JSON.parse(err["_body"]).message);
        }
      );
    }
  }
  openpopup(event, id) {
    var thisobj = this;
    $(event.target).popover({
      trigger: "hover",
    });

    $(function () {
      $(".pop").popover({
        trigger: "hover",
      });
    });
  }
  addVendorFromModal() {
    this.addVendorToChild(this.childofCat.id, this.childofCat.item_name);
  }
  data_heir;
  arrayOFLength = ["", "", "", "", "", "", ""];
  SliChildId: any;
  openPanelModal(pro, id) {
    $("#glassAnimals2").modal("show");
    this.showConfig = false;
    this.data_heir = pro;
    this.SliChildId = id;
    console.log(pro);
  }
  matserLineItemId: any;
  editOrCreateValidator: any = "";
  IDsOFMasterItems = [];
  LobReadonly: any;
  DepartmentReadonly: any;
  subDepartmentReadonly: any;
  ClassReadonly: any;
  subClassReadonly: any;
  MatcodeReadonly: any;
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  transform(value: string): string {
    return value.replace(/_/g, " ");
  }

  getEditDetails(id) {
    this.DepartmentListFilter = this.DepartmentList;
    this.SubDepartmentFilter = this.SubDepartmentList;
    this.ClassesFilter = this.classList;
    this.SubClassesFilter = this.SubClassList;
    this.MaterialCodeFilter = this.MaterialList;
    this.LoaderService.display(true);
    this.LeadService.getMasterDetails(id).subscribe(
      (res) => {
        res = res.master_line_item;
        this.getQuoteContainer();

        this.matserLineItemId = res.id;
        this.editOrCreateValidator = "edit";
        this.ProductTypeForm.controls["mli_name"].setValue(res.mli_name);
        this.ProductTypeForm.controls["category_lob_id"].setValue(
          res.category_lob_name[0].id
        );
        this.LobReadonly = this.transform(
          this.capitalizeFirstLetter(res.category_lob_name[0].name)
        );
        this.DepartmentReadonly = this.transform(
          this.capitalizeFirstLetter(res.category_department_name[0].name)
        );
        this.subDepartmentReadonly = this.transform(
          this.capitalizeFirstLetter(res.category_sub_department_name[0].name)
        );
        this.ClassReadonly = this.transform(
          this.capitalizeFirstLetter(res.category_class_name[0].name)
        );
        this.subClassReadonly = this.transform(
          this.capitalizeFirstLetter(res.category_sub_class_name[0].name)
        );
        this.MatcodeReadonly = this.transform(
          this.capitalizeFirstLetter(res.category_material_code_name[0].name)
        );
        this.ProductTypeForm.controls["category_department_id"].setValue(
          res.category_department_name[0].id
        );
        this.ProductTypeForm.controls["category_sub_department_id"].setValue(
          res.category_sub_department_name[0].id
        );
        this.ProductTypeForm.controls["category_class_id"].setValue(
          res.category_class_name[0].id
        );
        this.ProductTypeForm.controls["category_subclass_id"].setValue(
          res.category_sub_class_name[0].id
        );
        this.ProductTypeForm.controls["category_material_code_id"].setValue(
          res.category_material_code_name[0].id
        );
        this.ProductTypeForm.controls["zoho_category_id"].setValue(res.zoho_category_id?res.zoho_category_id:'');
        this.ProductTypeForm.controls["unit"].setValue(res.unit);
        this.ProductTypeForm.controls["tax_percent"].setValue(res.tax_percent);
        this.ProductTypeForm.controls["mli_type"].setValue("2021");

        this.ProductTypeForm.controls["sku_code"].setValue("");

        var MLI_array = this.ProductTypeForm.get(
          "mli_attributes_attributes"
        ) as FormArray;
        (<FormArray>MLI_array).controls = [];

        console.log(MLI_array);
        for (var i = 0; i < res.dynamic_attributes.length; i++) {
          this.IDsOFMasterItems.push(res.dynamic_attributes[i].id);
          MLI_array.push(
            this.formBuilder.group({
              attr_name: new FormControl(
                res.dynamic_attributes[i].attr_name,
                Validators.required
              ),
              id: new FormControl(
                res.dynamic_attributes[i].id,
                Validators.required
              ),

              required: new FormControl(
                res.dynamic_attributes[i].required,
                Validators.required
              ),
              attr_type: new FormControl(
                res.dynamic_attributes[i].attr_type,
                Validators.required
              ),
              attr_data_type: new FormControl("string"),
              dropdown_options: new FormControl(
                res.dynamic_attributes[i].dropdown_options.join(",")
              ),
            })
          );
        }

        this.LoaderService.display(false);
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  UpdatePROcode(data2) {
    console.log(data2);
    if (data2.mli_attributes_attributes.length > 0) {
      for (var i = 0; i < data2.mli_attributes_attributes.length; i++) {
        console.log(data2.mli_attributes_attributes[i].dropdown_options);
        if (
          Array.isArray(data2.mli_attributes_attributes[i].dropdown_options) ==
          false
        ) {
          data2.mli_attributes_attributes[i].dropdown_options =
            data2.mli_attributes_attributes[i].dropdown_options.split(",");
          if (data2.mli_attributes_attributes[i].dropdown_options.length == 0) {
            this.errorMessageShow(
              "Please give dropdown options properly with comma seperated"
            );
          }
        }
      }
    }

    let data = {
      master_line_item: data2,
    };

    this.LoaderService.display(true);
    this.LeadService.updateProduct(data, this.matserLineItemId).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("Product Updated Successfully");
        this.ProductTypeForm.reset();
        this.createProForm();
        this.productTypesel = "numberone";
        this.LoaderService.display(true);
        this.LeadService.ListOfPRoduct(
          this.current_page,
          this.SearchString,this.selectType
        ).subscribe(
          (res) => {
            this.LoaderService.display(false);
            this.headers_res = res.headers._headers;
            this.per_page = this.headers_res.get("x-per-page");
            this.total_page = this.headers_res.get("x-total");
            this.current_page = this.headers_res.get("x-page");
            res = res.json();
            this.ListOfProduct = res.master_line_items;
            this.masterLinteItem = this.ListOfProduct.filter((el) => {
              return el.id == this.matserLineItemId;
            });
            this.masterLinteItem = this.masterLinteItem[0];
            console.log(this.masterLinteItem);
            this.getChilditemListWithoutError(
              this.masterLineItemId,
              this.current_page2
            );
          },
          (err) => {
            this.LoaderService.display(false);
            this.ListOfProduct = [];
          }
        );

        this.getQuoteContainerquit();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  countDecimals(value) {
    if (Math.floor(value) === value) return 0;
    return value.toString().split(".")[1].length || 0;
  }

  numTofixed(num) {
    let count = this.countDecimals(num);
    if (count != 0) {
      return num.toFixed(2);
    } else {
      return num;
    }
  }
  EditOrCreateForChild = "";
  child_id_for_submit;
  EditChild(id, pro) {
    this.child_id_for_submit = id;
    pro = pro.dynamic_attributes;
    let attributenames = [];

    for (var i = 0; i < pro.length; i++) {
      attributenames.push(pro[i].attr_name);
    }

    this.LoaderService.display(true);
    this.LeadService.getchildDetails(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        res = res.child_line_item;
        this.ChildEditorCreate = "edit";
        this.getQuoteContainer2(this.masterSKU, res.master_line_item_id);
        this.EditOrCreateForChild = "edit";
        this.ProductChildTypeForm.controls["item_name"].setValue(res.item_name);
        this.ProductChildTypeForm.controls["tax"].setValue(res.tax);
        // this.ProductChildTypeForm.controls["sku"].setValue(res.sku);
        this.ProductChildTypeForm.controls["brand_code"].setValue(res.brand_code);
        this.ProductChildTypeForm.controls["brand_id"].setValue(res.brand_id);
        var MLI_array = this.ProductChildTypeForm.get(
          "sli_dynamic_attributes_attributes"
        ) as FormArray;
        (<FormArray>MLI_array).controls = [];
        for (var i = 0; i < res.sli_attributes.length; i++) {
          MLI_array.push(
            this.formBuilder.group({
              attr_value: new FormControl(
                res.sli_attributes[i].attr_value,
                res.sli_attributes[i].mli_attribute_details.required
                  ? Validators.required
                  : Validators.nullValidator
              ),
              id: new FormControl(res.sli_attributes[i].id),
              mli_attribute_id: new FormControl(
                res.sli_attributes[i].mli_attribute_details.id
              ),
              mli_attribute_name: new FormControl(
                res.sli_attributes[i].mli_attribute_details.attr_name
              ),
              mli_attribute_type: new FormControl(
                res.sli_attributes[i].mli_attribute_details.attr_type
              ),
              mli_attribute_value: new FormControl(
                res.sli_attributes[i].mli_attribute_details.dropdown_options
              ),
              mli_attribute_required: new FormControl(
                res.sli_attributes[i].mli_attribute_details.required
              ),
            })
          );
        }
        console.log(MLI_array);
      },

      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  removeFromItem(id) {
    if (id != "") {
      this.LoaderService.display(true);
      this.LeadService.DeleteAttribute(id).subscribe(
        (res) => {
          this.LoaderService.display(false);
          this.successMessageShow("Attribute Deleted SuccessFully");
        },
        (err) => {
          this.LoaderService.display(false);
          this.errorMessageShow(JSON.parse(err["_body"]).message);
        }
      );
    }
  }
  removeFromItemChild(id) {
    if (id != "") {
      this.LoaderService.display(true);
      this.LeadService.DeleteAttributeChild(id).subscribe(
        (res) => {
          this.LoaderService.display(false);
          this.successMessageShow("Attribute Deleted SuccessFully");
        },
        (err) => {
          this.LoaderService.display(false);
          this.errorMessageShow(JSON.parse(err["_body"]).message);
        }
      );
    }
  }
  submitchildproedit() {
    this.LoaderService.display(true);
    this.LeadService.EditProductchild(
      this.ProductChildTypeForm.value,
      this.child_id_for_submit
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.ProductChildTypeForm.reset();
        this.creatingFOrms();
        this.successMessageShow("Child Item updated Successfully");
        this.GetProductList(this.current_page);
        this.getChilditemList(this.masterLineItemId, this.current_page2);
        this.productTypeselchild = "numberonechild";
        this.modalclose();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }

  setUpvaluesInchild(data,parent) {
    this.ProductChildTypeForm.controls['tax'].setValue(parent.tax_percent)
    var MLI_array = this.ProductChildTypeForm.get(
      "sli_dynamic_attributes_attributes"
    ) as FormArray;
    (<FormArray>MLI_array).controls = [];
    for (var i = 0; i < data.length; i++) {
      MLI_array.push(
        this.formBuilder.group({
          attr_value: new FormControl(
            "",
            data[i].required ? Validators.required : Validators.nullValidator
          ),
          id: new FormControl(""),
          mli_attribute_name: new FormControl(data[i].attr_name),
          mli_attribute_id: new FormControl(data[i].id),
          mli_attribute_type: new FormControl(data[i].attr_type),
          mli_attribute_value: new FormControl(data[i].dropdown_options),
          mli_attribute_required: new FormControl(data[i].required),
        })
      );
    }
    this.ChildEditorCreate = "love";
  }
  showConfig = false;
  handleConfig() {
    this.showConfig = !this.showConfig;
  }
  SelectedIdOfVendor: any;
  alternative() {
    $("#glassAnimals3").modal("show");
    this.SelectedIdOfVendor = 1;
  }

  vendorFilterSel = "";
  selectType = "";
  FilterTypeVendororSearch = "parent_name";
  selectFiltertype(e) {
    this.FilterTypeVendororSearch = e;
    this.ParentSearch = "";
    this.ChildSearch = "";
    this.vendorFilterSel = "";
    this.search_type = e;
    this.SetLocalStorate('type',this.selectType)

  }
  changeFunforSelect(e) {
    this.vendorFilterSel = e;
  }
  selectReviseList(e) {
    console.log(e);
  }
  modalHideVen() {
    console.log("hi");
    $("#glassAnimals").modal("hide");
  }
  listOfBrands = [];
  getBrandsList() {
    this.LeadService.GetListBrands().subscribe((res) => {
      this.listOfBrands = res.brands;
    });
  }
  setValPro(e, i) {
    if (e == "dropdown") {
      this.ProductTypeForm.controls["mli_attributes_attributes"]["controls"][
        i
      ].controls.dropdown_options.setValidators(Validators.required);
      this.ProductTypeForm.controls["mli_attributes_attributes"]["controls"][
        i
      ].controls.dropdown_options.updateValueAndValidity();
    } else {
      this.ProductTypeForm.controls["mli_attributes_attributes"]["controls"][
        i
      ].controls.dropdown_options.clearValidators();
      this.ProductTypeForm.controls["mli_attributes_attributes"]["controls"][
        i
      ].controls.dropdown_options.setValue([]);
      this.ProductTypeForm.controls["mli_attributes_attributes"]["controls"][
        i
      ].controls.dropdown_options.updateValueAndValidity();
    }
  }
  catname: any;
  ParentSearch;
  ChildSearch;
  modalForVendor(vName) {
    $("#MoreVendor").modal("show");
    this.catname = vName;
  }
  SearchFilterForchild() {
    if (this.selectType != "") {
      this.GetProductList2("");
    } else {
      this.errorMessageShow("Please Select Search Type then Search");
    }
  }
  deleteVendorProduct(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteVendorProduct(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.ViewVendor2(this.childOfmas);
        this.getChilditemList(this.masterLineItemId, this.current_page2);
        this.GetProductList(this.current_page);
        this.successMessageShow("Vendor Product Deleted Successfully");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  vendor_details_forPro: any;
  editVendorGet(ven) {
    this.vendor_details_forPro = ven;
    $("#EditVendorModal").modal("show");
    this.VendorProductEditForm.controls["ItemCost"].setValue(ven.rate);
    this.VendorProductEditForm.controls["priority"].setValue(
      ven.vendor_details.priority
    );
    this.VendorProductEditForm.controls["child_line_item_id"].setValue(
      ven.child_line_item_id
    );
    this.VendorProductEditForm.controls["VendorId"].setValue(ven.vendor_id);
    this.VendorProductEditForm.controls["VendorCode"].setValue(
      ven.vendor_details.vendor_code
    );

    console.log(ven);
    console.log(this.VendorProductEditForm.value);
  }
  UpdateVendorProduct() {
    this.LoaderService.display(true);
    this.LeadService.UpdateVendorType(
      this.VendorProductEditForm.value,
      this.vendor_details_forPro.id
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.GetProductList(this.current_page);
        this.successMessageShow("Vendor Updated Succesfully");
        this.ViewVendor2(this.childOfmas);
        this.getChilditemList(this.masterLineItemId, this.current_page2);

        $("#EditVendorModal").modal("hide");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  endpoint_result: any = "";
  CheckingPriorityEndpoint(id) {
    this.ProirityOfven = "set";
    this.LeadService.prioritycheck(id).subscribe(
      (res) => {
        this.endpoint_result = res;
        $("#ViewProirityVendor").modal("show");
        this.getQuoteContainerquit2();
      },
      (err) => {
        if (
          JSON.parse(err["_body"]).message ==
          "There is no existing Preferred Vendor Item"
        ) {
          this.LoaderService.display(true);
          this.LeadService.CreateVendorType(
            this.ProductVendorForm.value
          ).subscribe(
            (res) => {
              console.log(res);
              this.LoaderService.display(false);
              if (res.message) {
                this.successMessageShow(res.message);
              } else {
                this.successMessageShow("Vendor product Created successfully");
              }

              this.ProductVendorForm.reset();
              this.creatingFOrms();
              $("#ViewProirityVendor").modal("hide");
              this.GetProductList(this.current_page);
              this.getQuoteContainerquit2();
              this.getChilditemList(this.masterLineItemId, this.current_page2);
              this.ViewVendor2(this.childOfmas);
              this.ProductVendorForm.controls["child_line_item_id"].setValue(
                this.childItemId
              );
              this.ProductVendorForm.controls["childsku"].setValue(
                this.ChildSku
              );
            },
            (err) => {
              this.LoaderService.display(false);
              this.errorMessageShow(JSON.parse(err["_body"]).message);
            }
          );
        }
      }
    );
  }
  ProirityOfven: any = "set";
  setUpproIrity(e) {
    console.log(this.ProirityOfven);
  }
  SUbVendorProduct() {
    this.ProductVendorForm.controls["priority"].setValue(this.ProirityOfven);
    console.log(this.ProirityOfven);
    this.LoaderService.display(true);
    this.LeadService.CreateVendorType(this.ProductVendorForm.value).subscribe(
      (res) => {
        console.log(res);
        this.LoaderService.display(false);
        if (res.message) {
          this.successMessageShow(res.message);
        } else {
          this.successMessageShow("Vendor product Created successfully");
        }

        this.ProductVendorForm.reset();
        this.creatingFOrms();
        $("#ViewProirityVendor").modal("hide");
        this.GetProductList(this.current_page);
        this.getQuoteContainerquit2();
        this.getChilditemList(this.masterLineItemId, this.current_page2);
        this.ViewVendor2(this.childOfmas);
        this.ProductVendorForm.controls["child_line_item_id"].setValue(
          this.childItemId
        );
        this.ProductVendorForm.controls["childsku"].setValue(this.ChildSku);
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  GetorderMangae(data, name) {
    let fildata = data.filter((el) => {
      if (el.mli_attribute_details && el.mli_attribute_details.attr_name) {
        return el.mli_attribute_details.attr_name == name;
      }
    });
    if (fildata.length > 0) {
      fildata = fildata[0];
      fildata = fildata.attr_value;
    } else {
      fildata = "-";
    }
    return fildata;
  }
  modalForSub() {
    $("#ViewSubDepartmentModal").modal("show");
  }

  // heirachy Elements edit and delete
  deletelob(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteLOB(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.getLOBSList();
        this.successMessageShow("LOB Sucessfully Deleted");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  LOBID: any;
  editLOBGet(ven) {
    this.EditLOBForm.controls["name"].setValue(ven.name);
    this.EditLOBForm.controls["lob_code"].setValue(ven.lob_code);
    $("#EditLOBModal").modal("show");
    this.LOBID = ven.id;
  }
  UpdateLOB() {
    this.LoaderService.display(true);
    this.LeadService.UpDateLOb(this.EditLOBForm.value, this.LOBID).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Sucessfully UpDated");
        this.getlistItems();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  DepartmentID: any;
  editDepGet(ven) {
    this.EditLOBForm.controls["name"].setValue(ven.name);
    this.EditLOBForm.controls["lob_code"].setValue(ven.lob_code);
    $("#EditLOBModal").modal("show");
    this.DepartmentID = ven.id;
  }
  UpdateDep() {
    this.LoaderService.display(true);
    this.LeadService.UpDateDep(this.EditLOBForm.value, this.LOBID).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Sucessfully UpDated");
        this.getlistItems();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  deleteDep(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteDep(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.getLOBSList();
        this.successMessageShow("LOB Sucessfully Deleted");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  SubDepartmentID: any;
  editSubDepGet(ven) {
    this.EditLOBForm.controls["name"].setValue(ven.name);
    this.EditLOBForm.controls["lob_code"].setValue(ven.lob_code);
    $("#EditLOBModal").modal("show");
    this.SubDepartmentID = ven.id;
  }
  UpdateSubDep() {
    this.LoaderService.display(true);
    this.LeadService.UpDateSubDep(this.EditLOBForm.value, this.LOBID).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Sucessfully UpDated");
        this.getlistItems();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  deleteSUBDep(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteSubDep(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.getLOBSList();
        this.successMessageShow("LOB Sucessfully Deleted");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  ClassID: any;
  editClass(ven) {
    this.EditLOBForm.controls["name"].setValue(ven.name);
    this.EditLOBForm.controls["lob_code"].setValue(ven.lob_code);
    $("#EditLOBModal").modal("show");
    this.ClassID = ven.id;
  }
  UpdateClass() {
    this.LoaderService.display(true);
    this.LeadService.UpDateClass(this.EditLOBForm.value, this.LOBID).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Sucessfully UpDated");
        this.getlistItems();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  deleteClass(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteClass(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.getLOBSList();
        this.successMessageShow("LOB Sucessfully Deleted");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  SUbClassID: any;
  editSubClass(ven) {
    this.EditLOBForm.controls["name"].setValue(ven.name);
    this.EditLOBForm.controls["lob_code"].setValue(ven.lob_code);
    $("#EditLOBModal").modal("show");
    this.SUbClassID = ven.id;
  }
  UpdatesubClass() {
    this.LoaderService.display(true);
    this.LeadService.UpDateSUbClass(
      this.EditLOBForm.value,
      this.LOBID
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Sucessfully UpDated");
        this.getlistItems();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  deleteSubClass(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteSubClass(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.getLOBSList();
        this.successMessageShow("LOB Sucessfully Deleted");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  MATcodeID: any;
  editmat(ven) {
    this.EditLOBForm.controls["name"].setValue(ven.name);
    this.EditLOBForm.controls["lob_code"].setValue(ven.lob_code);
    $("#EditLOBModal").modal("show");
    this.MATcodeID = ven.id;
  }
  Updatemat() {
    this.LoaderService.display(true);
    this.LeadService.UpDateMatCode(
      this.EditLOBForm.value,
      this.LOBID
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("LOB Sucessfully UpDated");
        this.getlistItems();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  deletemat(id) {
    this.LoaderService.display(true);
    this.LeadService.DeleteMatcode(id).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.getLOBSList();
        this.successMessageShow("LOB Sucessfully Deleted");
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"]).message);
      }
    );
  }
  listOfSliCats;
  listOfslicats() {
    this.LeadService.GetListCats().subscribe((res) => {
      this.listOfSliCats = res;
    });
  }
  resetcat(){
    this.creatingFOrms();
    this.itemsShow = "MaterialCode";
    console.log("huih")
    this.showitems('MaterialCode');
  }
  search_type:any="parent";
  changeDateType(e) {
    this.search_type = e;
  }
  createBrand() {
    this.LoaderService.display(true);
    this.LeadService.createBrand(this.CreateBrandCodeForm.value).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.successMessageShow("Brand Created Successfully");
        this.getlistItems();
        this.CreateBrandCodeForm.reset();
        this.creatingFOrms();
      },
      (err) => {
        this.LoaderService.display(false);
        this.errorMessageShow(JSON.parse(err["_body"])[0]);
      }
    );
  }
  childforZoho:any;
  ZoHoData:any = [];
  SkuSaved:any

  AddMapModal(data,child){
    this.childforZoho = child;
    this.SkuSaved = data.sku
    if(data.mapped != null){

      this.getDataforZOHOmap(data.sku)

      $("#ViewZohoMapping").modal("show");

    }
  }

  getDataforZOHOmap(Param){
    this.ZohoorgChecker=[]

    this.LoaderService.display(true);

    this.LeadService.FetchZohomap(Param).subscribe(res=>{
      this.LoaderService.display(false);
       this.ZoHoData = res.data;
    },
    (err) => {
      this.LoaderService.display(false);
      this.errorMessageShow(JSON.parse(err["_body"])[0]);
    })
  }

  ZohoorgChecker=[]

  manualmap(id){

  this.ZohoorgChecker.push(id);

  }
  zoho_ID:any
  mapclick(id){


    let Obj = {

      'zoho_organization_id' : id,
      'zoho_item_id' : $("#ZohoID"+id).val(),
      'sku'  : this.SkuSaved
    }

  this.LoaderService.display(true);

    this.LeadService.ManualZohomap(Obj).subscribe(res=>{
      this.LoaderService.display(false);

      this.successMessageShow("Mapped Successfully");
      this.getDataforZOHOmap(this.SkuSaved);
      this.getChilditemList(this.masterLineItemId, this.current_page2);
     
       
    },
    (err) => {
      this.LoaderService.display(false);
      this.errorMessageShow(JSON.parse(err['_body']).message);
    })

  }
  automaticmap(id){
    let Obj = {

      'zoho_organization_id' : id,
      'sku'  : this.SkuSaved
    }
    this.LeadService.AutoZohomap(Obj).subscribe(res=>{
      this.LoaderService.display(false);

      this.successMessageShow("Mapped Successfully");
      this.getDataforZOHOmap(this.SkuSaved);
      this.getChilditemList(this.masterLineItemId, this.current_page2);
     
       
    },
    (err) => {
      this.LoaderService.display(false);
      this.errorMessageShow(JSON.parse(err['_body']).message);
    })




  }

  undo(id){

    let index = this.ZohoorgChecker.indexOf(id);

    this.ZohoorgChecker.splice(index,1)

  }
  Catswarhouse:any=[]

  getCategorysForWarhouse() {
    this.LeadService.GetListWCats().subscribe(res => {
      this.Catswarhouse = res.categories;
    },
      (err) => {
        this.errorMessageShow(JSON.parse(err['_body']).message);
      })

  }
  FiltersObject={}
  SetLocalStorate(name,value){

    this.fillLocalStorage()
    this.FiltersObject[name] = value
    localStorage.setItem('filtersValue',JSON.stringify(this.FiltersObject))

  }
  clearFilter(){
    this.selectType ='';
    this.SearchString ='';
    this.SetLocalStorate('type','')
    this.SetLocalStorate('search','');
    this.GetProductList('')
  }
fillLocalStorage(){
 this.FiltersObject['search'] = this.SearchString;
 this.FiltersObject['type'] =  this.selectType
}
  
}



// WEBPACK FOOTER //
// ./src/app/platform/category/category/category-hierachy/category-hierachy.component.ts